/* eslint-disable @typescript-eslint/no-unused-vars */
// TODO: remove the above eslint-disable line when we properly implement the handleOnHover action
import {
    getPageUrl,
    useAnalyticsClickEvent,
    useAnalyticsViewEvent,
    useMap,
} from 'rwl-ui';
import { ClickTargets, ViewTargets } from 'rwl-shared/dist/models/analytics';
import { useGlobal } from '../../../hooks';
import { useMapContext } from '../../../hooks/MapProvider';
import { JobMarker } from './JobMarker';
import { NeighborhoodJob } from 'rwl-shared/dist/models';
import { HoverState } from './BaseMarker';
import { IconOption } from 'rwl-shared/dist/models/widget';
import { DetailsMode, useContentDetails } from '../../../providers';

export const NeighborhoodMarkers = () => {
    const { config } = useGlobal();
    const { neighborhood } = useMapContext();
    const { map } = useMap();
    const sendViewEvent = useAnalyticsViewEvent();
    const sendClickEvent = useAnalyticsClickEvent();
    const { openDetails } = useContentDetails();

    const handleOnHover = (job: NeighborhoodJob, state: HoverState) => {
        // FIXME: This hover handler was firing off many many times per hover, don't send the events til we can fix that
        // sendViewEvent({
        //     url: getPageUrl(),
        //     target: ViewTargets.JOB_SUMMARY,
        //     workSite: job.id,
        // });
        // TODO: Other stuff here
    };

    const handleOnClick = (job: NeighborhoodJob) => {
        sendClickEvent({
            url: getPageUrl(),
            target: ClickTargets.JOB,
            workSite: job.id,
        });

        // Passing in empty array because we need to hydrate this job with the full job data
        openDetails(job.id, job.reviewId, [], DetailsMode.JOB);
    };

    return (
        <>
            {neighborhood?.jobs.map((job, index) => {
                const { lat, lng } = job?.geolocation ?? {};
                if (!map || !lat || !lng) {
                    return null;
                }
                return (
                    <JobMarker
                        key={index}
                        position={job?.geolocation}
                        iconTint={
                            config?.account.mapSettings['color'] ||
                            'var(--rwl-icon-default)'
                        }
                        icon={
                            config?.account.mapSettings['icon'] ||
                            IconOption.House
                        }
                        job={job}
                        onClick={() => handleOnClick(job)}
                        onHover={(state: HoverState) =>
                            handleOnHover(job, state)
                        }
                    />
                );
            })}
        </>
    );
};
